import { createUsersColumnDefinitions } from "../UserTableColumns";

const usersColumnDefinitions = createUsersColumnDefinitions();

export const USERS_FIXED_COLUMNS = Object.keys(usersColumnDefinitions).slice(
  0,
  2
);

export const DEFAULT_USERS_VISIBLE_COLUMNS = Object.keys(usersColumnDefinitions)
.filter((key) => !USERS_FIXED_COLUMNS.includes(key));

export const usersColumnOptions = Object.values(usersColumnDefinitions)
  .filter(({ key }) => !USERS_FIXED_COLUMNS.includes(key))
  .map(({ key, label }) => ({ text: label, value: key }));

export const csvExportHeaders = [
  { key: "id", label: "ID" },
  { key: "name", label: "Name" },
  { key: "createdAt", label: "User Created" },
  { key: "email", label: "Email" },
  { key: "role", label: "Role" },
  { key: "studio", label: "Studio" },
  { key: "enterprise", label: "Enterprise" },
  { key: "subscription", label: "Subscription" },
  { key: "subStart", label: "Sub Start" },
  { key: "subEnd", label: "Sub End" },
  { key: "platform", label: "Platform" },
  { key: "autoRenewal", label: "Auto Renewal" },
  { key: "sessions", label: "Sessions" },
  { key: "students", label: "Students" },
  { key: "creditCount", label: "Credits" },
  { key: "reportCredits", label: "Report Credits" },
];
